import React, { useState, useCallback, useEffect } from 'react';
import requests from 'api/requests';
import { Container, Grid, FormControl, TextField, IconButton, Divider } from '@mui/material';
import { AddOutlined } from '@mui/icons-material';
import UsersList from './emails_list';
import { useSnackbar } from 'notistack';
import { IEmail } from './types';
import InstanceModal from './instanceModal';
import { PaperBox } from './styles';


export default function DriverRequestEmails() {
  const [email, setEmail] = useState("");
  const [editEmail, setEditEmail] = useState<IEmail|null>(null);
  const [emails, setEmails] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const load = useCallback(() => {
    let data = {} as any;
    requests.getAll('/admin/driver/emails/', data).then((r:any) => {
      setEmails(r.body.results);
    })
  }, [])
  useEffect(() => load(), [load]);

  const Add = () => {
    let data:IEmail = {
      email: email
    };
    requests.post('/admin/driver/emails/', data).then((r:any) => {
      setEmail("");
      enqueueSnackbar("Адресу додано", {variant: 'success'});
      load();
    })
  }

  return (
    <div>
      <Container maxWidth="sm">
        <PaperBox>
          <form
            onSubmit={(e:any) => {
              e.preventDefault();
              Add();
            }}
          >
            <Grid container alignItems="flex-start" wrap="nowrap">
              <Grid item style={{flexGrow: 1}}>
                <FormControl fullWidth>
                  <TextField
                    label="E-mail"
                    placeholder="E-mail для повідомлень"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={email}
                    onChange={(event) => {
                      setEmail(event.target.value);
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item>
                <IconButton type="submit" color="secondary">
                  <AddOutlined />
                </IconButton>
              </Grid>
            </Grid>
          </form>
          
          <br/>
          <Divider/>
          <br/>
          <UsersList
            emails={emails}
            onEdit={(email) => setEditEmail(email)}
          />

          
        </PaperBox>
      </Container>

      { editEmail !== null ? (
        <InstanceModal
          instance={editEmail}
          onClose={()=>setEditEmail(null)}
          onDelete={()=>{
            setEditEmail(null);
            load();
          }}
          onSave={()=>{
            setEditEmail(null);
            load();
          }}
        />
      ): null }
    </div>
  );
}